module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Black.26ace61.woff";